/**
 * Video player
 * ------------------------------------------------------------------------------
 * A Video Player file that contains scripts to function
 * Vimeo Player API library
 * - https://www.npmjs.com/package/@vimeo/player
 *
 * @namespace VideoPlayer
 */

import Player from '@vimeo/player';

import cssClasses from '../helpers/cssClasses';
import {on} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-video-player="container"]',
  videoCovers: '[js-video-player="cover"]',
};

/**
 * Create a new Frame object to collect all videos.
 */
Frame.videoPlayers = (Frame.videoPlayers) ? Frame.videoPlayers : {};

/**
 * Export a new product gallery.
 */
export default () => {

  /**
   * Node selectors.
   */
  const nodeSelectors = {
    container: document.querySelectorAll(selectors.container),
    videoCovers: document.querySelectorAll(selectors.videoCovers),
  };

  /**
   * Generate each player in the page and adds it to the Frame.videoPlayers object.
   * Each item in the object can be targeted by the video container ID attribute.
   * -----
   * On pause the cover is shown again.
   */
  function generatePlayers() {
    Object.keys(nodeSelectors.container).forEach((index) => {
      const videoID = nodeSelectors.container[index].id;
      const video = new Player(videoID);

      Frame.videoPlayers[videoID] = video;

      video.on('pause', () => {
        document.querySelectorAll(`[data-video-player="${videoID}"]`)[0].classList.remove(cssClasses.hidden);
      });
    });
  }

  /**
   * Trigger events when clicking the cover.
   * The video starts playing and the cover gets hidden.
   */
  function setTriggerEvents() {
    Object.keys(nodeSelectors.videoCovers).forEach((index) => {
      const element = nodeSelectors.videoCovers[index];
      const videoID = element.dataset.videoPlayer;
      on('click', element, () => {
        element.classList.add(cssClasses.hidden);
        playVideo(videoID);
      });
    });
  }

  /**
   * Play video function.
   * @param {String} videoID the video ID of the Vimeo video.
   */
  function playVideo(videoID) {
    Frame.videoPlayers[videoID].play();
  }

  function init() {
    generatePlayers();
    setTriggerEvents();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
